import type { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#1976d2",
  },
  components: {
    Collapse: {
      headerBg: "#e9e9e9",
      contentBg: "#ffffff",
    },
  },
};
